<template>
  <v-app id="inspire">
    <v-app-bar app
               flat
               tile
               color="primary">

      <v-toolbar-title>
        <v-img src="/v2/images/mobilelocker_logo_white.png"
               contain
               width="170"
               height="40"
               alt="Mobile Locker Logo"/>
      </v-toolbar-title>
    </v-app-bar>

    <v-main>
      <!--<impersonating-user>
      </impersonating-user>-->
      <transition name="page"
                  mode="out-in">
        <router-view></router-view>
      </transition>
    </v-main>
    <error-snackbar>
    </error-snackbar>
    <success-snackbar>
    </success-snackbar>
    <page-footer>
    </page-footer>
  </v-app>
</template>

<script>
import {mapGetters} from 'vuex'
import AppBar from '../components/AppBar';
import moment from 'moment-timezone';
import NavigationDrawer from '../components/NavigationDrawer';
import PageFooter from '../components/PageFooter';
import ImpersonatingUser from '../components/ImpersonatingUser';
import ErrorSnackbar from "../components/ErrorSnackbar";
import SuccessSnackbar from "../components/SuccessSnackbar";

export default {
  components: {SuccessSnackbar, ErrorSnackbar, ImpersonatingUser, PageFooter, NavigationDrawer, AppBar},
  data() {
    return {
      // Using null as the starting value for its v-model will initialize the drawer as closed on mobile and as open on desktop.
      drawer: false,
      year: moment().format('YYYY'),
    }
  },
  computed: {
    ...mapGetters([
      'authenticated',
      'user',
    ]),
  },
  methods: {
    async logout() {
      await this.$store.dispatch('logout');
    },
  }
}
</script>
